import { Controller } from "@hotwired/stimulus"

// Guarda y restaura la posición del scroll de la página a través de las recargas.
export default class extends Controller {
  connect() {
    // Restaura la posición al cargar la página
    this.restoreScrollPosition()

    // Guarda la posición justo antes de que la página se descargue
    window.addEventListener("beforeunload", this.saveScrollPosition)
  }

  disconnect() {
    // Limpia el listener cuando el controlador se desconecta
    window.removeEventListener("beforeunload", this.saveScrollPosition)
  }

  saveScrollPosition = () => {
    const scrollPosition = {
      x: window.scrollX,
      y: window.scrollY
    }
    sessionStorage.setItem("scrollPosition", JSON.stringify(scrollPosition))
  }

  restoreScrollPosition() {
    const scrollPosition = JSON.parse(sessionStorage.getItem("scrollPosition"))
    if (scrollPosition) {
      // Usamos requestAnimationFrame para asegurarnos de que el DOM está listo
      // antes de intentar hacer scroll.
      requestAnimationFrame(() => {
        window.scrollTo(scrollPosition.x, scrollPosition.y)
        // Opcional: limpiar la posición para que no se aplique en navegaciones normales
        // sessionStorage.removeItem("scrollPosition") 
      })
    }
  }
}
